import { defineKey as T } from 'ha/i18n';

export const ACTION_PREFIX = 'PAYOUTS/BILLING';
export const STATE_NAME = 'payoutsBilling';
export const BILLING_INFORMATION_FORM_NAME = 'UpdateBillingInfoForm';

export const messages = {
  SAVED: T('Your changes were saved'),
};

export const errorMessagesByFields = {
  firstName: T('Wrong first name'),
  lastName: T('Wrong last name'),
  address: T('Wrong address'),
  address2: T('Wrong apartment number'),
  state: T('Wrong state'),
  city: T('Wrong city'),
  vat: T('Wrong VAT ID'),
  zip: T('Wrong postalcode'),
  unknown: T('Unknown error'),
};

export const PERSON = 'physical-person';
export const COMPANY = 'company';
export const HIDE_VAT_ID = 'hide-vat-id';
export const SHOW_VAT_ID = 'show-vat-id';
